import { Component } from 'react';
import { Typography, Button, OutlinedInput, InputAdornment, Tooltip, Dialog, Box, ButtonGroup, TextField } from '@mui/material';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import '../../Laboratory/HomeTab/home.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import { withTranslation } from 'react-i18next';
import { ImagePaths } from '../../../Utility/ImagePaths';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import CircularProgress from '@mui/material/CircularProgress';
import { DeletePopup } from '../../../Components/Common Components/CommonComponents';

class IPRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchkey: "",
            ipRequestData: [],
            tab: 'request',
            transmitData: [],
            transmitDate: new Date(),
            proceedLoader: false,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            deletePopupOpen: false,
            selectedItem: null,
        }
    }
    componentDidMount() {
        this.getIPRequest();
        this.getTransmitList();
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getIPRequest() {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.IP_REQUEST_HOME + "?search_key=" + this.state.searchkey)
                .then(response => {
                    if (response.data.status == "success") {
                        this.setState({
                            ipRequestData: response.data.data
                        }, () => { this.LoaderFunction(false) });
                    }
                })
                .catch(e => {
                    this.LoaderFunction(false)
                    this.errorMsgFunc(e?.reponse?.data?.message || e.message)
                });
        }
        catch (e) {
            this.errorMsgFunc(e.message)
        }
    }

    getTransmitList = () => {
        try {
            const date = DateTime.fromJSDate(this.state.transmitDate).toFormat('yyyy-MM-dd');
            if (date === 'Invalid DateTime') return;
            this.LoaderFunction(true);
            RestAPIService.getAll(`${Serviceurls.IP_MEDICATION_TRANSMIT_LIST}?transmitted_date=${date}`)
                .then((response) => {
                    if (response.data?.status === 'success') {
                        this.setState({ transmitData: Array.isArray(response.data.data) ? response.data.data : [] }, () => this.LoaderFunction(false));
                    } else {
                        this.setState({ transmitData: [], isLoader: false });
                    }
                })
                .catch((e) => {
                    this.LoaderFunction(false);
                    this.errorMsgFunc(e?.response?.data?.message || e.message);
                });
        } catch (e) {
            this.errorMsgFunc(e?.message);
        }
    };

    getTransmitDrugDetail = (item) => {
        const ipTransmitId = (item.ip_transmit_id || []).join(',');
        const prescriptionId = (item.prescription_id || []).join(',');
        const refillRequestId = (item.refill_request_id || []).join(',');
        if (!ipTransmitId && !prescriptionId) {
            this.errorMsgFunc('No transmit or prescription data');
            return;
        }
        this.setState({ proceedLoader: true });
        const params = new URLSearchParams();
        if (ipTransmitId) params.set('ip_transmit_id', ipTransmitId);
        if (prescriptionId) params.set('prescription_id', prescriptionId);
        params.set('refill_request_id', refillRequestId || '');
        RestAPIService.getAll(`${Serviceurls.IP_MEDICATION_TRANSMIT_DRUG_DETAIL}?${params.toString()}`)
            .then((response) => {
                this.setState({ proceedLoader: false });
                if (response.data?.status === 'success') {
                    const drugLines = Array.isArray(response.data.data) ? response.data.data : [];
                    const billDetails = {
                        patient_id: item.patient_id,
                        ip_admission_id: item.ip_admission_id,
                        patient_name: item.patient_name,
                        patient_mobile: item.mobile_number,
                        patient_account_number: item.patient_account_number,
                        doctor_name: item.doctor_name,
                        doctor_id: item.doctor_id,
                        doctor_reg_no: item.doctor_reg_no || '',
                        line_items: drugLines,
                        ip_transmit_id: item.ip_transmit_id,
                    };
                    this.props.properties.history.push({
                        pathname: '/PharmacyBilling',
                        state: { isFromIpRequest: true, billDetails },
                    });
                    this.props.onClickrequestClose(false);
                } else {
                    this.errorMsgFunc(response.data?.message || 'Failed to load drug details');
                }
            })
            .catch((e) => {
                this.setState({ proceedLoader: false });
                this.errorMsgFunc(e?.response?.data?.message || e.message);
            });
    };
    errorMsgFunc = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMsgFunc = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    // Handle Deny button click
    handleDenyClick = (item) => {
        this.setState({
            deletePopupOpen: true,
            selectedItem: item
        });
    }

    // Handle delete confirmation
    handleDeleteConfirm = () => {
        if (this.state.selectedItem) {
            this.denyIPRequest(this.state.selectedItem);
        }
        this.setState({
            deletePopupOpen: false,
            selectedItem: null
        });
    }

    // Handle delete popup close
    handleDeletePopupClose = () => {
        this.setState({
            deletePopupOpen: false,
            selectedItem: null
        });
    }

    // API call to deny IP request
    denyIPRequest = (item) => {
        try {
            let data = {
                id: item.id
            }
            RestAPIService.create(data, Serviceurls.IP_REQUEST_DENY)
                .then(response => {
                    if (response.data.status === "success") {
                        this.successMsgFunc("IP request denied successfully");
                        this.getIPRequest();
                    }
                })
                .catch(e => {
                    this.errorMsgFunc(e?.response?.data?.message || e.message || "Failed to deny IP request");
                });
        }
        catch (e) {
            this.errorMsgFunc(e.message || "Failed to deny IP request");
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    render() {
        const { t } = this.props
        return (
            <Dialog className="emed_DialogboxOrder" open={this.props.open} onClose={this.props.onClose} maxWidth={"md"} style={{ overflowY: 'hidden' }}>
                <div style={this.props.recallKey ? { width: "40vw" } : { width: "34vw" }} >
                    <div style={{ display: "flex", margin: "0.5vw", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1000, padding: "0.5vw 0", }}>
                        <label style={{ flex: "0.5" }}><b>{t("In Patient Request")}</b></label>
                        <div style={{ flex: "0.5", display: "flex", justifyContent: "end" }}
                            onClick={() => { this.props.onClickrequestClose(false) }}>
                            <img
                                src={ImagePaths.LabCloseButton.default}
                                style={{ cursor: "pointer", height: "1vw", width: "1vw" }}
                                alt=""
                            />
                        </div>
                    </div>

                    <ButtonGroup size="small" sx={{ mb: 1, ml: 0.5 }}>
                        <Button variant={this.state.tab === 'request' ? 'contained' : 'outlined'} onClick={() => this.setState({ tab: 'request' })} sx={{ textTransform: 'capitalize' }}>{t("Request")}</Button>
                        <Button variant={this.state.tab === 'transmitted' ? 'contained' : 'outlined'} onClick={() => this.setState({ tab: 'transmitted' }, () => this.getTransmitList())} sx={{ textTransform: 'capitalize' }}>{t("Transmitted")}</Button>
                    </ButtonGroup>

                    {this.state.tab === 'request' && (
                    <div style={{ display: 'flex', justifyContent: 'end', position: "sticky", top: "3vw", backgroundColor: "white", zIndex: 1000, paddingBottom: '0.5vw', padding: "0.5vw 0" }}>
                        <OutlinedInput
                            placeholder="Search Patients..."
                            onChange={(e) => {
                                this.setState({
                                    searchkey: e.target.value
                                }, () => {
                                    this.getIPRequest()
                                })
                            }}
                            value={this.state.searchkey}
                            size="small"
                            sx={{ width: "13vw", marginRight: "0vw" }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <i class="fas fa-search"></i>
                                </InputAdornment>
                            }
                            inputProps={{ emed_tid: "IPreq_search_bill" }}
                        />
                    </div>
                    )}

                    {this.state.tab === 'transmitted' && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5vw 0', marginBottom: '0.5vw' }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label=""
                                maxDate={new Date()}
                                value={this.state.transmitDate}
                                inputFormat="dd-MM-yyyy"
                                onChange={(newValue) => {
                                    this.setState({ transmitDate: newValue > new Date() ? new Date() : newValue }, () => this.getTransmitList());
                                }}
                                renderInput={(params) => <TextField size="small" sx={{ width: '12vw' }} {...params} />}
                            />
                        </LocalizationProvider>
                    </div>
                    )}

                    <div style={{
                        height: "25vw",
                        width: this.props.recallKey ? '40vw' : '35vw',
                        overflow: this.props.recallKey ? "auto" : 'hidden',
                    }}>
                        {this.state.tab === 'request' && this.state.ipRequestData && this.state.ipRequestData.length > 0 ?
                            <div className='eMed_Pres_DataView' style={this.props.recallKey ? { width: '39vw', overflow: 'visible' } : { width: '33.5vw' }}>
                                {this.state.ipRequestData.map((item, index) => {
                                    var count = item?.line_items?.length
                                    return (
                                        <Box emed_tid="IPreq_toBill_item"
                                            className="Lab_Home_Saved_Bill" style={{ cursor: 'pointer' }}>
                                            <div style={{ flex: 0.1 }}>{index + 1}</div>
                                            <div style={{ flex: 0.22 }}><img src={ImagePaths.Male.default} alt='Avatar' /></div>
                                            <div style={{ flex: this.props.recallKey ? 0.70 : 0.60 }}>
                                                {item?.patient_name.length > 15 ?
                                                    <Tooltip title={item?.patient_name} placement='top'>
                                                        <Typography className='savedBillText'>{item?.patient_name ? item?.patient_name.slice(0, 15) + '...' : '-'}</Typography>
                                                    </Tooltip> : <Typography className='savedBillText'>{item?.patient_name ? item?.patient_name : '-'}</Typography>}
                                                <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${item?.patient_mobile ? item?.patient_mobile : '-'} | ${item?.patient_account_number ? item?.patient_account_number : '-'}`}</Typography>
                                                {item?.ip_number && (
                                                (item?.ip_number?.length > 15 ?
                                                    <Tooltip title={item?.ip_number} placement='top'>
                                                        <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'IP No: ' + (item?.ip_number ? '...' + item.ip_number.slice(15) : '-')}`}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'IP No: ' + (item?.ip_number ? item?.ip_number : '-')}`}</Typography>)
                                                )}
                                            </div>
                                            <div style={{ flex: this.props.recallKey ? 0.30 : 0.20 }}>
                                                <Typography className='savedBillText' style={{ width: '6vw' }}>{item?.created_date ? item?.created_date : '-'}</Typography>
                                                <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'Drug Count: ' + (count ? count : '0')}`}</Typography>
                                            </div>

                                            <div style={{ flex: 0.40, display: 'flex', justifyContent: 'center' }}>
                                                <Button size="small" variant="contained" color="primary" sx={{ textTransform: 'capitalize' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.props.properties.history.push({ pathname: "/PharmacyBilling", state: { isFromIpRequest: true, billDetails: item } })
                                                        this.props.onClickrequestClose(false)
                                                    }}
                                                > Proceed
                                                </Button>
                                            </div>
                                            {this.props.recallKey ? <div style={{ flex: 0.40, display: 'flex', justifyContent: 'center' }}>
                                                <Button size="small" variant="contained" color="error" sx={{ textTransform: 'capitalize' }}
                                                    onClick={this.props.recallKey ? (e) => {
                                                        e.stopPropagation();
                                                        this.handleDenyClick(item);
                                                    } :
                                                        () => {
                                                            this.props.properties.history.push({ pathname: "/PharmacyBilling", state: { isFromIpRequest: true, billDetails: item } })
                                                            this.props.onClickrequestClose(false)
                                                        }
                                                    }
                                                >
                                                    Deny
                                                </Button>
                                            </div> : null}
                                        </Box>
                                    )
                                })}

                            </div> :
                        this.state.tab === 'transmitted' && this.state.transmitData && this.state.transmitData.length > 0 ?
                            <div className='eMed_Pres_DataView' style={this.props.recallKey ? { width: '39vw', overflow: 'visible' } : { width: '33.5vw' }}>
                                {this.state.transmitData.map((item, index) => {
                                    const prescriptionCount = Array.isArray(item.prescription_id) ? item.prescription_id.length : (item.prescription_count || 0);
                                    return (
                                        <Box key={index} emed_tid="IPtransmit_toBill_item" className="Lab_Home_Saved_Bill" style={{ cursor: 'pointer' }}>
                                            <div style={{ flex: 0.1 }}>{index + 1}</div>
                                            <div style={{ flex: 0.22 }}><img src={ImagePaths.Male.default} alt='Avatar' /></div>
                                            <div style={{ flex: this.props.recallKey ? 0.70 : 0.60 }}>
                                                <Typography className='savedBillText'>{item?.patient_name ? (item.patient_name.length > 15 ? item.patient_name.slice(0, 15) + '...' : item.patient_name) : '-'}</Typography>
                                                <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${item?.mobile_number || '-'} | ${item?.patient_account_number || '-'}`}</Typography>
                                                <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{item?.doctor_name ? item.doctor_name : '-'}</Typography>
                                            </div>
                                            <div style={{ flex: this.props.recallKey ? 0.30 : 0.20 }}>
                                                <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'Prescription: ' + prescriptionCount}`}</Typography>
                                            </div>
                                            <div style={{ flex: 0.40, display: 'flex', justifyContent: 'center' }}>
                                                <Button size="small" variant="contained" color="primary" sx={{ textTransform: 'capitalize' }} disabled={this.state.proceedLoader}
                                                    onClick={(e) => { e.stopPropagation(); this.getTransmitDrugDetail(item); }}
                                                > {this.state.proceedLoader ? <CircularProgress size={20} /> : 'Proceed'}
                                                </Button>
                                            </div>
                                        </Box>
                                    );
                                })}
                            </div> :
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%'
                            }}>
                                {this.state.isLoader ?
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        className='eMed_App_DataView'>
                                        <CircularProgress /></div>
                                    : <div><Typography id='eMed_Pres_pop_NORec'>{t("No records found")}</Typography></div>}
                            </div>}
                    </div>
                    {this.state.deletePopupOpen && (
                        <DeletePopup
                            DeletTitle={("Are you sure you want to deny the IP request.")}
                            DeleteNotify={t("This action cannot be undone")}
                            deleteAlertPopupClose={this.handleDeletePopupClose}
                            removeData={this.handleDeleteConfirm}
                        />
                    )}
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                </div>
            </Dialog >
        );
    }
}
export default withTranslation()(IPRequest)